import { matchPath } from 'react-router';

const whiteboardPattern = '/wiki/spaces/:spaceKey/whiteboard/:contentId';
const whiteboardMatchConfig = {
	path: whiteboardPattern,
	exact: true,
};

type WhiteboardMatchParams = {
	spaceKey: string;
	contentId: string;
};

export const getWhiteboardUrlMatch = (url: string) => {
	const urlObject = new URL(url);
	const path = urlObject.pathname;
	const match = matchPath<WhiteboardMatchParams>(path, whiteboardMatchConfig);
	return match;
};
